module.exports = __webpack_public_path__ + "static/img/cont.26aea99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/myshop/cont.png
// module id = nFC2
// module chunks = 152